import React from 'react'
import ReactDOM from 'react-dom'
import { persistor, store } from './store'
import { Provider as ReduxStoreProvider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import App from './App'
import { SWRConfig } from 'swr'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import BugsnagPerformance from '@bugsnag/browser-performance'
import { Button } from 'react-bootstrap'

Bugsnag.start({
  apiKey: '9f5856f9e5a6eee6cbace775485738ac',
  plugins: [new BugsnagPluginReact()],
})
BugsnagPerformance.start({ apiKey: '9f5856f9e5a6eee6cbace775485738ac' })

const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React)

const fetcher = (input: RequestInfo | URL, init?: RequestInit) => fetch(input, init).then((res) => res.json())

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <SWRConfig value={{ fetcher }}>
        <ReduxStoreProvider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>
        </ReduxStoreProvider>
      </SWRConfig>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
